// extracted by mini-css-extract-plugin
export default {"about":"Inf_about__Bj2am","bio":"Inf_bio__e8jtu","slider":"Inf_slider__4JmQH"};